import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { authLogin } from '../Actions/Auth';
import { Navigate } from 'react-router-dom';
import { setAlert } from '../Actions/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import styles from "./LoginForm.module.css"

const LoginAuth = () => {
    const dispatch = useDispatch();
    const [redirect, setRedirect] = useState('')

    useEffect(() => {
        // Function to parse query parameters from the URL
        const getQueryParam = (name) => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        };

        // Retrieve token from the URL
        const token = getQueryParam('token');
        const error = getQueryParam('error');

        // If a token is found, dispatch the authLogin action
        if (token) {
            dispatch(authLogin(token));
            setRedirect('/');
        }

        if (error) {
            dispatch(setAlert('Invalid Login', 'danger' ));
            setRedirect('/login');
        }
    }, [dispatch]);

    if (redirect!='') {
        return <Navigate to={redirect}></Navigate>
    }

    return (
        <div className={styles.spinner}><FontAwesomeIcon icon={faBolt} size="3x" /></div>
    );
};

export default LoginAuth;
